import { Logger } from 'aws-amplify';

import { appConfig } from 'src/config/config';

const logger = new Logger(`${appConfig.appName} Logger`, process.env.REACT_APP_LOGGING_LEVEL);

export default logger;
